export const exportFilesCustomStyles = {
    //Colombia
    "1": {
        //Hino
        "1": () => import('./col/hino/siteConfig').then(m => m.siteConfig),
        //Subaru
        "2": () => import('./col/subaru/siteConfig').then(m => m.siteConfig),
        //DFSK
        "3": () => import('./col/dfsk/siteConfig').then(m => m.siteConfig),
        //BMW
        "4": () => import('./col/bmw/siteConfig').then(m => m.siteConfig),
        //Derco
        "8": () => import('./col/derco/siteConfig').then(m => m.siteConfig)
    },
    //Peru
    "2": {
        //Hino
        "1": () => import('./peru/hino/siteConfig').then(m => m.siteConfig),
        //Subaru
        "2": () => import('./peru/subaru/siteConfig').then(m => m.siteConfig),
        //DFSK
        "3": () => import('./peru/dfsk/siteConfig').then(m => m.siteConfig),
        //BMW
        "4": () => import('./peru/bmw/siteConfig').then(m => m.siteConfig),
        //Mini
        "5": () => import('./peru/mini/siteConfig').then(m => m.siteConfig),
        //BMW Motorrad
        "6": () => import('./peru/bmwMotorrad/siteConfig').then(m => m.siteConfig),
        //BYD
        "7": () => import('./peru/byd/siteConfig').then(m => m.siteConfig),
        //Derco
        "8": () => import('./peru/derco/siteConfig').then(m => m.siteConfig),
        //Jac Autos
        "10": () => import('./peru/jacAutos/siteConfig').then(m => m.siteConfig),
        //Jac Camiones
        "11": () => import('./peru/jacCamiones/siteConfig').then(m => m.siteConfig),
        //Changan
        "13": () => import('./peru/changan/siteConfig').then(m => m.siteConfig),
        //Suzuki
        "14": () => import('./peru/suzuki/siteConfig').then(m => m.siteConfig),
        //Land Rover
        "19": () => import('./peru/landRover/siteConfig').then(m => m.siteConfig)
    },
    //Chile
    "3": {
        //Hino
        "1": () => import('./chile/hino/siteConfig').then(m => m.siteConfig),
        //BMW
        "4": () => import('./chile/bmw/siteConfig').then(m => m.siteConfig),
        //Mini
        "5": () => import('./chile/mini/siteConfig').then(m => m.siteConfig),
        //BMW Motorrad
        "6": () => import('./chile/bmwMotorrad/siteConfig').then(m => m.siteConfig),
    },
    //Belgium
    "4": {
        //BYD
        "7": () => import('./belgium/byd/siteConfig').then(m => m.siteConfig),
    },
    //Panama
    "5": {},
    //Costa Rica
    "6": {},
    //Kenia
    "7": {
        //Hino
        "1": () => import('./Kenia/hino/siteConfig').then(m => m.siteConfig),
        //Subaru
        "2": () => import('./Kenia/subaru/siteConfig').then(m => m.siteConfig),
        //DFSK
        "3": () => import('./Kenia/dfsk/siteConfig').then(m => m.siteConfig),
        //Mini
        "5": () => import('./Kenia/mini/siteConfig').then(m => m.siteConfig),
        //Citroen
        // "9": () => import('./CustomStyles/kenia/citroen/siteConfig').then(m => m.siteConfig),
        //Suzuki
        "14": () => import('./Kenia/suzuki/siteConfig').then(m => m.siteConfig),
        //Land Rover
        "19": () => import('./Kenia/landRover/siteConfig').then(m => m.siteConfig),
        //Mercedes-Benz
        "20": () => import('./Kenia/mercedesBenz/siteConfig').then(m => m.siteConfig),
    },
    //Philippines
    "8": {},
    //Indonesia
    "9": {
        //Mercedes-Benz
        "20": () => import('./indonesia/mercedesBenz/siteConfig').then(m => m.siteConfig),
    }
}